import React from 'react';
import { AwardIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { assurances, checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="bg-surface/40 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-133" data-mp="1ja0dw0krprkr">
      <div className="mx-auto max-w-3xl px-4" data-id="element-134" data-mp="1n9ireba9f0dk">
        <SectionHeading id="pricing-title" data-id="element-135" data-mp="1ncwp367zaleo">Scegli la tua <span className="text-accent" data-id="element-136" data-mp="1s8lx7xy2daml">opzione</span></SectionHeading>

        <article id="offerta" className="mt-10 scroll-mt-6 overflow-hidden rounded-3xl border-2 border-primary bg-background/70 shadow-2xl shadow-black/50" data-id="element-137" data-mp="1x8zucky4n05u">
          <div className="border-b border-primary/30 bg-surface/40 px-6 py-4 sm:px-10" data-id="element-138" data-mp="2271ktqxvu1rc">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent/50 bg-accent/10 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-foreground" data-id="element-139" data-mp="2w9yvys41iwc">
              <AwardIcon className="h-3.5 w-3.5 text-primary" aria-hidden="true" data-id="element-140" data-mp="1mi99x2rwowj9" /> Offerta principale
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-141" data-mp="1ho544mudmujr">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-142" data-mp="1crwrbg3njdfr">
              <div data-id="element-143" data-mp="17sjvi5usyw11">
                <h3 className="text-2xl font-extrabold uppercase leading-tight tracking-tight text-foreground sm:text-3xl" data-id="element-144" data-mp="17t3fds40juhp">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-145" data-mp="20gfyfsaytk69">
                  Tutti i {totalVolumes} volumi + {totalBonuses} bonus esclusivi
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-146" data-mp="1vjftxltrkph9">
                <span className="text-sm text-muted" data-id="element-147" data-mp="1rgj7tl50mb8k">
                  Prezzo normale: <span className="line-through decoration-primary decoration-2" data-id="element-148" data-mp="k1xxl7eiis4r">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-primary" data-id="element-149" data-mp="g0cn1spgapxq">Oggi:</p>
                <p className="mt-1 whitespace-nowrap text-5xl font-extrabold leading-none tracking-tight text-primary sm:text-6xl" data-id="element-150" data-mp="hhhyyytws6c6">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-151" data-mp="7ju3g6ohausy">
              Sì, voglio l&apos;Edizione Professionale
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-152" data-mp="3uwo2byf42ovt">
              {assurances.map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-153" data-mp="3j1tfb7s8lvm">
                  <CheckCircle2Icon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-154" data-mp="3kz9om6kkoe77" /> {item}
                </span>)}
            </div>
          </div>
        </article>
      </div>
    </section>;
}